import { render, staticRenderFns } from "./org-list.vue?vue&type=template&id=04e18c4f&scoped=true&"
import script from "./org-list.vue?vue&type=script&lang=js&"
export * from "./org-list.vue?vue&type=script&lang=js&"
import style0 from "./org-list.vue?vue&type=style&index=0&id=04e18c4f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e18c4f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04e18c4f')) {
      api.createRecord('04e18c4f', component.options)
    } else {
      api.reload('04e18c4f', component.options)
    }
    module.hot.accept("./org-list.vue?vue&type=template&id=04e18c4f&scoped=true&", function () {
      api.rerender('04e18c4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/rebate/channel-cost-config/form/org-list.vue"
export default component.exports